module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.926a08fb.ttf";